import GameEditModal from './GameEditModal';

export default GameEditModal;
